const preventDragHandler = (e) => {
  e.preventDefault();
};

export default preventDragHandler;
